let _dataBucketEnumID = 0;

export enum DataBucketTypeEnum {
  NONE = _dataBucketEnumID++,
  LOCATIONS = _dataBucketEnumID++,
  SINGLE_LOCATION = _dataBucketEnumID++,
  HOTELS = _dataBucketEnumID++,
  DRIVETIME = _dataBucketEnumID++,
  THEMATIC = _dataBucketEnumID++,
  CIRCLE = _dataBucketEnumID++,
  RULERTOOL = _dataBucketEnumID++,
  CUSTOMER_DOTS = _dataBucketEnumID++,
  GEOLOCATION = _dataBucketEnumID++,
  TERRITORY = _dataBucketEnumID++,
  SINGLE_TERRITORY = _dataBucketEnumID++,
  SINGLE_PUSHPIN = _dataBucketEnumID++,
  POINTSOFINTEREST = _dataBucketEnumID++,
  CUSTOMER_HEATMAP = _dataBucketEnumID++,
  PROFILE_THEMATIC = _dataBucketEnumID++,
  CUSTOMER_THEMATIC = _dataBucketEnumID++,
  ACTUAL_CUSTOMER_HEATMAP = _dataBucketEnumID++,
  ENHANCED_TRAFFIC = _dataBucketEnumID++,
  IMPACT_ANALYSIS = _dataBucketEnumID++,
  DEMAND_ANALYSIS = _dataBucketEnumID++,
  HOUSEHOLD_ANALYSIS = _dataBucketEnumID++,
  BUSINESS_ANALYSIS = _dataBucketEnumID++,
  EXPLORE_LOCATION = _dataBucketEnumID++,
  EXPLORE_GEOGRAPHY = _dataBucketEnumID++,
  PUSHPINS = _dataBucketEnumID++,
  BUSINESS = _dataBucketEnumID++,
  BOUNDARY = _dataBucketEnumID++,
  CLOUD_DATA = _dataBucketEnumID++,
  SEARCH = _dataBucketEnumID++,
  CLUSTER_ITEMS = _dataBucketEnumID++,
  LOCATION_LIFECYCLE = _dataBucketEnumID++,
  LOCATION_FILTERS = _dataBucketEnumID++,
  GOOGLEPLACE = _dataBucketEnumID++,
  DRAWINGTOOLS = _dataBucketEnumID++,
  REPORTS = _dataBucketEnumID++,
  MY_MARKET = _dataBucketEnumID++,
  VISUALIZATION = _dataBucketEnumID++,
  HOTEL_COMPETITOR = _dataBucketEnumID++,
  WORKFLOW = _dataBucketEnumID++,
}
